import { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';

import { getColor } from 'basic-components';

export default class LinkSegmentWidget extends Component {
  render() {
    const Bottom = cloneElement(
      this.props.factory.generateLinkSegment(
        this.props.link,
        this.props.selected || this.props.link.isSelected(),
        this.props.path
      ),
      {
        filter: this.props.selected
          ? "drop-shadow(0 0 4px 0 rgba(0, 0, 0, .2))"
          : "",
        ref: this.props.segmentRef,
        stroke: getColor("grey-base"),
      }
    );

    const Top = cloneElement(Bottom, {
      strokeLinecap: "round",
      onMouseLeave: () => {
        this.props.onSelection(false);
      },
      onMouseEnter: () => {
        this.props.onSelection(true);
      },
      ref: null,
      "data-linkid": this.props.link.getID(),
      strokeOpacity: 0,
      strokeWidth: 20,
      fill: "none",
      onContextMenu: e => {
        if (!this.props.link.isLocked()) {
          e.preventDefault();
          this.props.link.remove();
        }
      }
    });

    return (
      <g>
        {Bottom}
        {Top}
      </g>
    );
  }
}

LinkSegmentWidget.defaultProps = {
  path: undefined
}

LinkSegmentWidget.propTypes = {
  factory: PropTypes.any.isRequired,
  link: PropTypes.any.isRequired,
  onSelection: PropTypes.func.isRequired,
  path: PropTypes.any,
  segmentRef: PropTypes.any.isRequired,
  selected: PropTypes.bool.isRequired
};
